module.exports = __webpack_public_path__ + "static/media/it.1d72a5de.svg";